export default __webpack_public_path__ + "static/media/stopWatch.97f5a4b3.png";